module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 21-a0e076358acfc2fafcd52d1bf7e0d9f2.png";